import type React from 'react';
import { forwardRef } from 'react';
import type { ContinueButtonProps, FormElement } from '@/formbuilder/formBuilder.constants';
import { FormBuilder } from '@/formbuilder/FormBuilder.page';
import type { ButtonVariant } from '@seeqdev/qomponents';

interface ToolPanelFormBuilderProps extends ContinueButtonProps {
  // the formDefinition Array of FormElements defines the form to be rendered
  formDefinition: FormElement[];
  // the function that is called when the form is submitted
  submitFn: (values: unknown) => void;
  // the function that is called when the cancel button is clicked
  closeFn: () => void;
  // id of the tool (legacy - may no longer apply)
  toolId?: string;
  // id of the submitBtnId (legacy - may no longer apply)
  submitBtnId?: string;
  // if debug is enabled then the form values and form errors are rendered below this form;
  debug?: boolean;
  // option to have the submit button say something other than 'Execute'
  submitBtnLabel?: string;
  // option to hide the cancel button
  hideCancel?: boolean;
  // CSS classes to apply to the cancel button
  cancelClassNames?: string;
  // wrap the form in a panel
  wrapInPanel?: boolean;
  // extra classnames applied if not wrapped in panel
  extraClassNamesUnwrapped?: string;
  // option to pass a ref to access submit button status
  ref?: React.ForwardedRef<boolean | undefined>;
  buttonExtraClassNames?: string;
  // disable the submit button
  submitBtnDisabled?: boolean;
  // adds a popover to switch between multiple submit options
  submitOptions?: { key: string; label: string; variant?: ButtonVariant; submitFn: (values: unknown) => unknown }[];
  /** by default we assume we're creating a tool panel, however if we want to use a CancelAndSave as the button
   component we can do so by setting this to true **/
  saveAndCancel?: boolean;
}

/**
 * ToolPanelFormBuilder generates tool forms based on the provided form definition Array.
 **/
export const ToolPanelFormBuilder = forwardRef<boolean | undefined, ToolPanelFormBuilderProps>(
  function ToolPanelFormBuilder(props, ref) {
    return <FormBuilder {...props} ref={ref} />;
  },
);
